module.exports = __webpack_public_path__ + "static/media/zonajobs.ddca20fb.svg";